<template lang="pug">
.container(id="NetworkSelector-container")
  h4(v-if='header') {{ header }}
  hr.header(v-if='header')
  el-form(id="NetworkSelector-form" label-width="200px")
    el-form-item(:label="$t('Client / Network')")
      el-input.el-input(id="NetworkSelector-formClientOrNetworkInput" v-model='params.clientOrNetworkName', type="text", name="clientOrNetworkName", ref="clientOrNetworkName", :placeholder="$t('client or network name')", @input='handleClientOrNetworkInputChange()')
  table
    tr(v-for='client in clients', :key='client.id', :id="'NetworkSelector-formTableRowClient' + client.id")
      th
        p {{ client.name }}
      td
        p.network(v-for='network in client.Networks', :key='network.id', @click='selectNetwork(network)', :id="'NetworkSelector-formTableColumnNetwork' + network.id")
          span {{ network.name }}
  p.error(v-if='errors.length > 0' id="NetworkSelector-notFoundError")
    span {{ $t('No such clients found.') }}
  ConfirmDialog(
    id="NetowrkSelector-confirmDialog",
    :confirmDialogVisible='confirmDialogVisible',
    :question='confirmDialogQuestion',
    :data='rightClickData',
    @confirmed='dialogConfirmed',
    @closed='dialogDenied'
  )
</template>
<script>
import Vue from 'vue'
import ConfirmDialog from './ConfirmDialog'

export default {
  components: {
    ConfirmDialog
  },
  created () {
  },
  props: ['header'],
  mixins: [
  ],
  data () {
    return {
      errors: [],
      clients: [],
      clientSelected: null,
      params: {
        clientOrNetworkName: ''
      },
      searchURL: 'client',
      confirmDialogQuestion: null,
      confirmDialogVisible: false,
      rightClickData: {}
    }
  },
  methods: {
    async dialogDenied (data) {
      this.confirmDialogVisible = false
      this.rightClickData = {}
      this.confirmDialogQuestion = null
    },
    async dialogConfirmed (network) {
      await this.selectNetworkCommit(network)
      this.confirmDialogQuestion = null
      this.confirmDialogVisible = false
      this.rightClickData = {}
    },
    async handleClientOrNetworkInputChange () {
      if (this.params.clientOrNetworkName.length < 3) return null
      this.__searchForClient()
    },
    async __searchForClient () {
      this.errors = []
      this.clients = []
      await Vue.axios.post(
        'client/searchByName',
        this.params
      ).then(response => {
        if (response.data.length === 0) return this.errors.push('not found')
        this.clients = response.data
      }).catch(e => {
        this.errors = []
        this.errors.push(e)
      })
    },
    selectNetwork (network) {
      this.confirmDialogQuestion = `
        ${this.$t('Are you sure you want to move this device to network ')}
        ${network.name}?`
      this.rightClickData = network
      this.confirmDialogVisible = true
    },
    selectNetworkCommit (network) {
      this.$emit('networkSelected', network)
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.error {
  color: $--color-warning;
}
table {
  margin-left: 10px;
  padding: 0px;
  border-spacing: 0px;
  padding: 0px;
  // max-width: 90%;
  tr {
    th, td {
      border-bottom: $--border-light;
    }
    th {
      p {
        margin-right: 20px;
      }
    }
    .network {
      cursor: pointer;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Common/NetworkSelector.vue